const PasswordTypes = {
  CHANGE_PASSWORD_REQUEST: "CHANGE_PASSWORD_REQUEST",
  CHANGE_PASSWORD_RESPONSE: "CHANGE_PASSWORD_RESPONSE",
  CHANGE_PASSWORD_CLEAR: "CHANGE_PASSWORD_RESPONSE_CLEAR",
};

export default PasswordTypes;
